module.exports = __webpack_public_path__ + "img/main_logo_text_white.4506fba8.png";